<!-- index.vue (你的主页面) -->
<template>
  <div>
    <!-- 触发按钮，传入当前操作的行数据(模拟) -->
    <el-button type="text" @click="showDialog()">
      绑定兔喜
    </el-button>

    <!-- 弹窗 A 组件 -->
    <BindQueryDialog
      v-model:visible="dialogAVisible"
      :site-name="currentStation.siteName"
      :site-code="currentStation.siteCode"
      @query-success="onQuerySuccess"
    />

    <!-- 弹窗 B 组件 -->
    <BindConfirmDialog
      v-model:visible="dialogBVisible"
      :store-info="queriedStoreInfo"
      :site-code="currentStation.siteCode"
      @bind-success="onBindSuccess"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import BindQueryDialog from '@/components/tdl/site-manage/BindQueryDialog.vue'
import BindConfirmDialog from '@/components/tdl/site-manage/BindConfirmDialog.vue'
import { useCurrentAppInstance } from '@zto/zpage-runtime'
const app = useCurrentAppInstance()
const props = withDefaults(
  defineProps<{
    contextData?: any
    baseInfoRowData?: any
  }>(),
  {
    contextData: {},
    baseInfoRowData: {}
  }
)

// 状态控制
const dialogAVisible = ref(false)
const dialogBVisible = ref(false)

// 存储当前操作的站点信息和查到的门店信息
const currentStation = reactive({ siteCode: '', siteName: '' })
const queriedStoreInfo = ref({})

// 1. 点击按钮：记录当前站点，打开弹窗 A
const showDialog = () => {
  // console.log('===打开弹窗A===', JSON.stringify(props.baseInfoRowData))
  currentStation.siteCode = props.baseInfoRowData.siteCode
  currentStation.siteName = props.baseInfoRowData.siteName
  dialogAVisible.value = true
}

// 2. 接收弹窗 A 查询成功的数据：保存数据，并打开弹窗 B
const onQuerySuccess = (data: any) => {
  console.log('===弹窗A查询成功，接收数据，打开弹窗B===', data)
  queriedStoreInfo.value = data
  dialogBVisible.value = true
}

// 3. 接收弹窗 B 绑定成功的通知：刷新列表
const onBindSuccess = () => {
  console.log('===弹窗B绑定成功，开始刷新列表===')
  // 在这里调用获取列表的接口，例如：
  // fetchTableData()
  app.triggerPageSearch()
}
</script>

<style scoped lang="scss">
/* 主页面样式 */
</style>
